import { useRef, useState, useEffect } from 'react'
import { SDrawerOrModal, SGeneralForms, SSegmentedTabs, SSteps } from 'shj-components'
import { Radio, Select, message } from 'antd';
import styles from '../../index.module.less'
import { useParams } from 'react-router-dom'
import {IConfig} from "shj-components/dist/es/SGeneralForms/type";
import { getBankList, getBankAreaList, getBankBranchList } from "@/services/fmsConfig";
import { startRefundRetail } from '@/services/order';
import { getChildrenDicts } from '@/services/index';

interface IProps {
  title: string
  open: boolean
  isBackTrack: boolean | undefined
  editRecord: object,
  listRef: object,
  setOpen: (open: boolean) => void
}
export default function DirectReFundDrawer(props: IProps) {
  const { open, title, setOpen, editRecord, isBackTrack = false, listRef = {} } = props
  const formRef: any = useRef(null)
  const { id } = useParams()
  const [bankAreaList, setBankAreaList] = useState<any>([])
  const [bankList, setBankList] = useState<any>([])
  const [bankBranchList, setBankBranchList] = useState<any>([])

  useEffect(() => {
    formRef.current?.onFormRef().setFieldsValue({
      isReturnGoods: false,
    })
  }, [])

  useEffect(() => {
    try {
      formRef.current?.onFormRef().setFieldsValue({
        refundChannel: isBackTrack ? 'REFUND_BACK_TRACK' : 'REFUND_OFFLINE',
        accountNature: isBackTrack ? '' : 'TO_PUBLIC',
      })
    } catch (err) {
      console.log(err)
    }
  }, [isBackTrack])

  const getOptions = async () => {
    const dicRes = await getChildrenDicts(['BackMoneyReason']);
    const bankLists = await getBankList({orderBys: [
      {
        columnName: '',
        asc: false
      }
    ]})
    const bankAreaLists = await getBankAreaList({orderBys: [
      {
        columnName: '',
        asc: false
      }
    ]})
    const reasonList = dicRes?.[0]?.children?.map(item => ({ label: item.name, value: item.priKey }))
    setBankAreaList(bankAreaLists)
    setBankList(bankLists)
    return Promise.resolve({
      bankList: bankLists,
      bankAreaList:bankAreaLists,
      reasonList,
    })
  }
  const getBankAddress = () =>{
    const { bankAreaCode, bankCode } = formRef.current?.onFormRef()?.getFieldsValue() || {};
    if (bankAreaCode && bankCode) {
      getBankBranchList({ bankCode, areaCode: bankAreaCode }).then((res) => {
        setBankBranchList(res)
      });
    }
  }
  const onSubmit = () => {
    formRef.current?.onFormRef().validateFields().then(async (values: any) => {
      const bankName = bankList.find(item => item.bankCode === values.bankCode)?.bankName;
      const branchName = bankBranchList.find(item => item.branchCode === values.branchCode)?.branchName;
      const res: any = await startRefundRetail({
        ...values,
        branchName,
        bankName,
        isReturnGoods: values.isReturnGoods ? 1 : 0,
        orderId: id,
        goodsId: editRecord.goodsId,
        paymentAmount: editRecord.totalPrice
      })
      if (res) {
        listRef?.current && listRef?.current.reload()
        message.success('退款申请成功');
        setOpen(false)
        return;
      }
    })
  }
  const filterOption1 = (input: any, option: any) => {
    return option.props.bankName.indexOf(input.toLowerCase()) >= 0;
  }
  const filterOption2 = (input: any, option: any) => {
    return option.props.areaName.indexOf(input.toLowerCase()) >= 0;
  }
  const filterOption3 = (input: any, option: any) => {
    return option.props.branchName.indexOf(input.toLowerCase()) >= 0;
  }
  const refundTypeList = [
    {
      value: 'REFUND_BACK_TRACK',
      label: '原路退回',
      disabled: !isBackTrack,
    },
    {
      value: 'REFUND_OFFLINE',
      label: '财务线下退款',
    },
  ]
  const configs: Array<IConfig> = [
    {
      formItem: [
        {
          label: '退款类型',
          name: 'refundChannel',
          spanCol: 24,
          required: true,
          data: 'list',
          type: 'select',
          rules: [{ required: true, message: '请填写' }],
          children: (text: any, record: any) => {
            return (
              <SSegmentedTabs
                options={refundTypeList}
                style={{ padding: 0 }}
                tabBarStyles={{
                  width: 'max-content',
                }}
                onChange={(e: any) => {
                  formRef.current?.onFormRef().setFieldsValue({
                    refundChannel: e,
                  })
                }}
              />
            )
          },
        },
        {
          label: '交款金额（元）',
          name: 'paymentAmount',
          spanCol: 24,
          children: () => (
            <span>{ editRecord?.totalPrice }</span>
          )
        },
        {
          label: '退款金额（元）',
          name: 'refundAmount',
          spanCol: 24,
          rules: [{ required: true, message: '请填写' }],
          required: true,
        },
        {
          label: '是否退货',
          name: 'isReturnGoods',
          spanCol: 24,
          required: true,
          type: 'switch',
          valuePropName: 'checked',
          comConfig: {
            checkedChildren: '是',
            unCheckedChildren: '否',
          },
          rules: [{ required: true, message: '请填写' }],
        },
        {
          label: '账户类型',
          name: 'accountNature',
          spanCol: 24,
          required: true,
          isDeps: true,
          deps: form => form.getFieldValue('refundChannel') === 'REFUND_OFFLINE',
          rules: [{ required: true, message: '请填写' }],
          children: (text: any, record: any) => {
            return (
              <Radio.Group>
                <Radio value={'publicAccount'}>对公</Radio>
                <Radio value={'privateAccount'}>对私</Radio>
              </Radio.Group>
            )
          },
        },
        {
          label: '开户名',
          name: 'accountName',
          spanCol: 24,
          isDeps: true,
          deps: form => form.getFieldValue('refundChannel') === 'REFUND_OFFLINE',
          rules: [{ required: true, message: '请填写' }],
          required: true,
        },
        {
          label: '客户银行卡号',
          name: 'accountNumber',
          spanCol: 24,
          isDeps: true,
          deps: form => form.getFieldValue('refundChannel') === 'REFUND_OFFLINE',
          rules: [{ required: true, message: '请填写' }],
          required: true,
        },
        {
          label: '开户银行名称',
          name: 'bankCode',
          spanCol: 12,
          isDeps: true,
          deps: form => form.getFieldValue('refundChannel') === 'REFUND_OFFLINE',
          required: true,
          children: (
            <Select
              placeholder="开户银行名称"
              showSearch
              filterOption={filterOption1}
              onChange={getBankAddress}
              options={bankList}
              fieldNames={{ label: 'bankName', value: 'bankCode' }}
            ></Select>
          ),
        },
        {
          label: '开户城市',
          name: 'bankAreaCode',
          spanCol: 12,
          required: true,
          isDeps: true,
          deps: form => form.getFieldValue('refundChannel') === 'REFUND_OFFLINE',
          children: (
            <Select
              placeholder="开户城市"
              showSearch
              filterOption={filterOption2}
              onChange={getBankAddress}
              options={bankAreaList}
              fieldNames={{ label: 'areaName', value: 'areaCode' }}
            ></Select>
          ),
        },
        {
          label: '客户银行网点',
          name: 'branchCode',
          isDeps: true,
          deps: form => form.getFieldValue('refundChannel') === 'REFUND_OFFLINE',
          spanCol: 24,
          required: true,
          children: (
            <Select placeholder='请选择客户银行网点' showSearch filterOption={filterOption3} options={bankBranchList} fieldNames={{ label: 'branchName', value: 'branchCode' }}>
            </Select>
          )
        },
        {
          label: '退款原因',
          name: 'reason',
          spanCol: 24,
          required: true,
          data: 'reasonList',
          type: 'select',
          comConfig: {
            fieldNames: { label: 'label', value: 'value' },
          },
        },
      ],
    },
  ]
  return (
    <div>
      <SDrawerOrModal
        title={title}
        mode="drawer"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
        okText="提交"
      >
        <div className={styles.addQuotationDrawer}>
          <SGeneralForms
            ref={formRef}
            // httpOptionsFn={getOptions}
            layout={'vertical'}
            configs={configs}
            httpOptionsFn={getOptions}
          />
        </div>
      </SDrawerOrModal>
    </div>
  )
}
